"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoCarouselDots = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _PhotoCarouselDot = require("../PhotoCarouselDot/PhotoCarouselDot");
var _PhotoCarouselDots = require("./PhotoCarouselDots.styles");
var _excluded = ["currentIndex", "maxDotsToDisplay", "total"];
/**
 * Container for multiple `PhotoCarousel.Dot` components.
 *
 * @since 8.66.0
 */
var PhotoCarouselDots = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var currentIndex = _ref.currentIndex,
    maxDotsToDisplay = _ref.maxDotsToDisplay,
    total = _ref.total,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  if (total < 2) {
    return [];
  }
  var paginationDots = [];

  /**
   * Normalize `currentIndex`, converting negative numbers or numbers greater than total.
   * Use result as `activeIndex`.
   */
  var indexOffset = Math.abs(currentIndex) % total;
  var activeIndex = currentIndex < 0 ? (total - indexOffset) % total : indexOffset;

  /**
   * Since there might be a lot of slides, we don't show a pagination dot for every
   * slide in the carousel.
   *
   * If there are more slides beyond the last dot, make that dot smaller
   * to show there is "continuation". Give similar treatment to the first dot.
   */
  var totalDots = Math.min(total, maxDotsToDisplay);
  var middle = Math.floor(maxDotsToDisplay / 2);
  var overflowing = total > maxDotsToDisplay;

  // Determine if there are more slides beyond the left and/or right of the dots.
  var overflowingLeft = overflowing && activeIndex > middle;
  var overflowingRight = overflowing && activeIndex + middle < total - 1;
  for (var i = 0; i < totalDots; i += 1) {
    // Determine if this is a "continuation" dot. If it is, it will display
    // smaller than the others as a visual affordance.
    var isFirstDot = i === 0;
    var isLastDot = i === totalDots - 1;
    var continuationLeft = isFirstDot && overflowingLeft;
    var continuationRight = isLastDot && overflowingRight;
    var isContinuation = continuationLeft || continuationRight;

    // Calculate this dot's slide index and whether it's the active slide
    var active = false;
    var slideIndex = 0;
    if (overflowingLeft) {
      if (overflowingRight) {
        active = i === middle;
        slideIndex = activeIndex - middle + i;
      } else {
        active = i === maxDotsToDisplay - (total - activeIndex);
        slideIndex = total - maxDotsToDisplay + i;
      }
    } else {
      active = i === activeIndex;
      slideIndex = i;
    }
    paginationDots.push( /*#__PURE__*/_react.default.createElement(_PhotoCarouselDot.PhotoCarouselDot, {
      isActive: active,
      isContinuation: isContinuation,
      key: slideIndex
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_PhotoCarouselDots.StyledPhotoCarouselDots, (0, _extends2.default)({
    ref: forwardedRef
  }, rest), paginationDots);
});
exports.PhotoCarouselDots = PhotoCarouselDots;
PhotoCarouselDots.displayName = 'PhotoCarouselDots';
PhotoCarouselDots.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The index of the active slide.
   */
  currentIndex: _propTypes.default.number.isRequired,
  /**
   * The maximum number of dots to display.
   */
  maxDotsToDisplay: _propTypes.default.number,
  /**
   * The total number of slides in the carousel.
   */
  total: _propTypes.default.number.isRequired
} : {};
PhotoCarouselDots.defaultProps = {
  maxDotsToDisplay: 5
};